// extracted by mini-css-extract-plugin
export default {"root":"YZTt0d","hoverOnEdit":"RKUlbf"};